function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m30 122h256v30h-256z",
  fill: "#41474d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m75 137h30v60h-30z",
  fill: "#41474d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m512 0v512h-151l-30-30h-60v-482z",
  fill: "#ff641a"
}), /*#__PURE__*/React.createElement("path", {
  d: "m391 0h121v512h-121z",
  fill: "#f03800"
}), /*#__PURE__*/React.createElement("path", {
  d: "m338.264 272h-126.949l-30.315 30-30 30v150l30 30h30l15.789-30 14.211 30h120v-210z",
  fill: "#cdf"
}), /*#__PURE__*/React.createElement("path", {
  d: "m211 272v60h-60v30h60v30h-60v30h60v30h-60v30h60v30h30v-240z",
  fill: "#41474d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m331 61v91h120v-91z",
  fill: "#41474d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m391 61h60v91h-60z",
  fill: "#282c33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m158.264 272h-127.949l-30.315 30v30l30 18.632-30 11.368v30l30 15.474-30 14.526v30l30 16.105-30 13.895v30h30l15.79-30 14.21 30h121v-210z",
  fill: "#e6f2ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30 272v60h-30v30h30v30h-30v30h30v30h-30v30h30v30h30v-240z",
  fill: "#5c6366"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271 182-90 60-30 30 30 30h180v-60z",
  fill: "#9bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "m90 182-90 60v60h181v-60z",
  fill: "#cdf"
}));

var SvgWaterChange = function SvgWaterChange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaterChange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water-change.c56fdd23.svg";
export { ForwardRef as ReactComponent };